<template>
  <Layout>
    <div class="industry-practice-page">
      <div class="industry-practice-page-content">
        <StaticBanner :banner-date="bannerData" />

        <div class="container" data-aos="zoom-in" v-if="imgData">
          <div class="ecop-ai-page_title">
            <div class="font-size-24 fw-bold tab-block_titles text-center lyd-title-colo1 color-black">{{imgData.title}}</div>
            <p class="font-size-14 text-center tab-block_titles">{{imgData.content}}</p>
          </div>
          <div class="ai_product_content">
            <img :src="imgData.img" alt="" />
          </div>
        </div>
        
        <!-- 产品展示 -->
        <div class="ai_productShow" v-if="productShowData" :class="{'bg_productShow': currentType === '0'}">
          <div class="container">
            <div class="ecop-ai-page_title" data-aos="fade-up">
              <div class="font-size-24 fw-bold tab-block_titles text-center lyd-title-colo1 text-balck">{{ productShowData.title }}</div>
              <p class="font-size-14 text-center tab-block_titles">{{ productShowData.content }}</p>
            </div>
            <div class="ai_productShow_content">
              <div class="ai_productShow_item" v-for="(item, index) in productShowData.list" :key="index" 
                :class="{'ai_productShow_item_reverse': item.type === '2', 'ai_productShow_item_5': currentType === '0'}" :data-aos="item.type === '1' ? 'zoom-in-right' : 'zoom-in-left'">
                <img class="ai_productShow_content_img" :src="item.img" alt="">
                <div class="ai_productShow_text">
                  <!-- <img src="@/assets/newImages/productSolution/多模态智能识别@2x.png" alt=""> -->
                  <div class="ai_productShow_text_title" v-html="item.title"></div>
                  <div class="ai_productShow_text_text">{{ item.content }}</div>
                </div>
              </div>
            </div>
          </div>

        </div>
        
        <div class="cardBlock" v-if="cardList" :class="{'bg_practice': currentType === '2'}">
          <EcopAiBlock :item-list="cardList.itemList" :title="cardList.title" :content="cardList.desc" :type="currentType == '5'?3:4" />
        </div>
        <div :class="{'practice-section': currentType === '1'}" v-if="practiceData">
          <div class="ecop-ai-page_title container" data-aos="fade-up" v-if="currentType !== '1'">
            <div class="font-size-24 fw-bold tab-block_titles text-center lyd-title-colo1 color-black">{{ practiceData.title }}</div>
            <p class="font-size-14 text-center tab-block_titles">{{ practiceData.content }}</p>
          </div>
          <ExpandableCards :items="practiceData.practiceList" />
        </div>
      </div>


    </div>
  </Layout>
</template>

<script>
import Layout from '@/components/common/Layout.vue'
import ExpandableCards from '@/components/common/ExpandableCards.vue'
import StaticBanner from '@/components/common/staticBanner/index.vue'
import EcopAiBlock from '@/components/common/ecopAiBlock/index.vue'

export default {
  name: 'industryPractice',
  components: {
    Layout,
    ExpandableCards,
    StaticBanner,
    EcopAiBlock
  },
  data() {
    return {
      currentType: '0',
      bannerData: {},
      practiceData: {},
      imgData: {},
      productShowData:{},
      cardList: {},
      dataMap: {
        '0': {
          bannerData: {
            url: require("@/assets/newImages/industryPractice/banner_AI穿透式监管方案.png"),
            title: '<span style="color:#152131">AI穿透式</span><span style="color:#1B75ED">监管方案</span>',
            content: '<span style="color:#586E8A">博信诚AI精准契合这一监管需求，以元生AI平台为核心，打破传统管控壁垒，打通数据洞察到业务落地的全链路，为央国企提供一体化数智监管服务。</span>',
            contentWidth: '600px'
          },
          imgData:{
            title: "元生AI平台，筑牢数智监管底座",
            content:"博信诚元生AI平台作为企业级AI大模型一站式应用平台，是穿透式监管解决方案的核心技术支撑。它融合先进模型、行业知识图谱与深度定制能力，可实现多智能体协作、任务编排、知识库管理等功能，为BossinData数据智能体、智审通AI审核平台提供强大技术赋能，打造“时时在线的数据大脑”，让监管更智能、更高效。",
            img:require("@/assets/newImages/industryPractice/AI穿透式监管方案_架构图.png")
          },
          productShowData:{
            title: "数据智能体+AI审核平台",
            content: "双轮驱动，实现全维度穿透监管",
            list:[
              {
                type: "1",
                img: require("@/assets/newImages/industryPractice/AI穿透式监管方案_场景一.png"),
                title: "BossinData数据智能体<br>破解数据壁垒，精准管控风险",
                content: "BossinData数据智能体深度贴合国资穿透式监管核心需求，摒弃传统数据工具碎片化、处理滞后的短板，依托元生AI平台实现全域数据贯通与智能闭环管控，助力企业轻松落实监管要求。",
              },
              {
                type: "2",
                img: require("@/assets/newImages/industryPractice/AI穿透式监管方案_场景二.png"),
                title: "智审通｜AI审核平台<br>合规可视化，风险早防范",
                content: "智审通AI审核平台聚焦合规审核与风险防控，依托算法内置的监管规则与风险阈值，对违规操作、资金异常等问题实现实时告警、精准溯源，构建“事前防范、事中阻断、事后追溯”的风险防控体系。",
              },
            ]
          },
          cardList: {
            title: "核心价值",
            desc: "双轮驱动，实现全维度穿透监管",
            itemList: [
              {
                img: require("@/assets/newImages/industryPractice/合规达标.png"),
                title: "合规达标",
                content: "全级次、全流程监管落地，严守国资安全与合规经营底线/检查超限、耗材不合规；",
              },
              {
                img: require("@/assets/newImages/industryPractice/风险可控.png"),
                title: "风险可控",
                content:"隐性风险精准识别、实时预警，构建全流程风险防控体系",
              },
              {
                img: require("@/assets/newImages/industryPractice/降本增效.png"),
                title: "降本增效",
                content: "7×24小时不间断赋能，替代人工低效工作，提升管控效率、降低人力成本",
              },
              {
                img: require("@/assets/newImages/industryPractice/数据增值.png"),
                title: "数据增值",
                content: "盘活企业数据资产，通过数据分析输出决策建议，助力精细化管理",
              }
            ],
          },
        },
        '1': {
          bannerData: {
            url: require("@/assets/newImages/industryPractice/行业_医疗banner@2x.png"),
            title: '<span style="color:#152131">博信诚依托 AI 大模型构建</span><span style="color:#1B75ED">医疗精准决策体系</span>',
            content: '<span style="color:#586E8A">既优化诊疗全流程效率与质量，又提升医疗资源配置科学性，助力智慧医疗生态完善实现行业服务能力与运营效率的双重升级。</span>',
            contentWidth: '600px'
          },
          practiceData: {
            title: "",
            content: "",
            practiceList: [
              {
                number: '01',
                title: '医院AI审核',
                content: 'AI审核是指通过AI智能技术实现审核全流程自动化，涵盖从智能填单、AI审核到智能记账的一站式、端到端解决方案，可助力医院提升审核记账的完整性、准确性、时效性以及风险控制的有效性，实现降本增效，智能风控。',
                image1: require('@/assets/newImages/industryPractice/医疗卡片1_选中状态@2x.png'),
                image: require('@/assets/newImages/industryPractice/医疗卡片1_初始状态@2x.png')
              },
              {
                number: '02',
                title: '医嘱与病历<br>审核质控智能体',
                content: '涵盖规则模型库、知识库、审核引擎、外部接口和智能应用服务，提供从“数据解析—规则模型匹配—合规审核—质控闭环”的全链路能力。通过集成临床路径、医保政策、药品与耗材目录，能够为医生提供实时的合规提示，为管理部门提供质控闭环支撑，全面提升医院运营质量与合规水平。',
                image: require('@/assets/newImages/industryPractice/医疗卡片2_初始状态@2x.png'),
                image1: require('@/assets/newImages/industryPractice/医疗卡片2_选中状态@2x.png')
              },
              {
                number: '03',
                title: '医院收入<br>运营数据智能体',
                content: '通过构建多层级的收入运营分析体系，实现从全院战略总览到科室绩效对比、从病种项目收益到单病历成本的逐级穿透。确保医院能够在不同层次上进行精细化管理与决策支持，形成“全院视角—科室对比—病种精算—个案洞察”的一体化分析框架。',
                image: require('@/assets/newImages/industryPractice/医疗卡片3_初始状态@2x.png'),
                image1: require('@/assets/newImages/industryPractice/医疗卡片3_选中状态@2x.png')
              }
            ]
          },
        },
        '2': {
          bannerData: {
            url: require("@/assets/newImages/industryPractice/banner_财务共享中心的AI风控审核方案.png"),
            title: '<span style="color:#152131">财务共享中心的</span><span style="color:#1B75ED">AI风控审核方案</span>',
            content: '<span style="color:#586E8A">博信诚智审通以共享模式为核心，依托前沿 AI 技术重构财务审核范式，打造全量穿透、制度即判断、异常智能识别的 "秒级风控质检" 能力，将财务规则、内控制度与专业经验转化为可自动执行的数字判断力，为财务共享中心构建高效、精准、合规的全流程风控防线。</span>',
            contentWidth: '600px'
          },
          imgData:{
            title: "财务共享中心的数智化风控中枢",
            content:"构建高效、精准、合规的全流程风控防线",
            img:require("@/assets/newImages/industryPractice/财务共享中心的AI风控审核方案_架构图.png")
          },
          cardList: {
            title: "核心功能",
            desc: "构建高效、精准、合规的全流程风控防线",
            itemList: [
              {
                img: require("@/assets/newImages/industryPractice/单据采集与智能识别.png"),
                title: "单据采集与智能识别",
                content: "支持纸质、电子单据及发票、合同、行程单等各类附件的自动采集，通过多模态识别技术精准提取结构化与非结构化信息，实现票据、文本、图像的全要素解析。",
              },
              {
                img: require("@/assets/newImages/industryPractice/规则引擎深度校验.png"),
                title: "规则引擎深度校验",
                content:"内置丰富财务规则库，支持自定义配置审核逻辑，对单据要素完整性、金额准确性、科目匹配度、预算合规性等进行刚性校验，确保基础审核零差错。",
              },
              {
                img: require("@/assets/newImages/industryPractice/大模型风险研判.png"),
                title: "大模型风险研判",
                content: "依托企业级大模型的语义理解、逻辑推理与知识关联能力，处理复杂场景、模糊表述与非标业务，识别传统规则无法覆盖的隐性风险与合规问题。",
              },
              {
                img: require("@/assets/newImages/industryPractice/智能体协同作业.png"),
                title: "智能体协同作业",
                content: "多智能体分工协作完成信息提取、规则校验、风险分析、结果输出等环节，实现审核流程自动化、无人化，降低人工依赖。",
              },
              {
                img: require("@/assets/newImages/industryPractice/风险提示与人工复核.png"),
                title: "风险提示与人工复核",
                content: '自动生成风险报告，明确标注风险等级、问题详情与合规依据，为人工复核提供精准指引，形成 "AI 自动审核 + 人工重点复核" 的高效协同模式。',
              }
            ],
          },
          practiceData: {
            title: "核心价值",
            content: "构建高效、精准、合规的全流程风控防线",
            practiceList: [
              {
                number: '01',
                title: '全量穿透审核',
                content: '突破传统抽样审核局限，对每一笔单据及所有附件实现 100% 全覆盖校验，不遗漏任何风险细节，从源头杜绝风险盲区。',
                image1: require('@/assets/newImages/industryPractice/医疗卡片1_选中状态@2x.png'),
                image: require('@/assets/newImages/industryPractice/医疗卡片1_初始状态@2x.png')
              },
              {
                number: '02',
                title: '制度即判断',
                content: '将企业财务制度、报销标准、合规要求、内控规范等固化为 AI 可识别的判断逻辑，让制度要求直接转化为系统自动执行的审核规则，确保审核标准统一、执行无偏差。',
                image: require('@/assets/newImages/industryPractice/医疗卡片2_初始状态@2x.png'),
                image1: require('@/assets/newImages/industryPractice/医疗卡片2_选中状态@2x.png')
              },
              {
                number: '03',
                title: '异常智能识别',
                content: '依托算法模型精准捕捉单据中的隐性风险、逻辑矛盾、违规特征与异常数据，自动标记风险点、清晰呈现依据、同步给出处理建议，实现风险 "早发现、明依据、快处置"。',
                image: require('@/assets/newImages/industryPractice/医疗卡片3_初始状态@2x.png'),
                image1: require('@/assets/newImages/industryPractice/医疗卡片3_选中状态@2x.png')
              },
              {
                number: '04',
                title: '秒级风控质检',
                content: '面对日均海量单据，实现毫秒级审核响应，大幅缩短审核周期，让高频业务审核从 "小时级" 降至 "秒级"，支撑财务共享中心高效运转。',
                image: require('@/assets/newImages/industryPractice/医疗卡片3_初始状态@2x.png'),
                image1: require('@/assets/newImages/industryPractice/医疗卡片3_选中状态@2x.png')
              }
            ]
          },
        },
      }
    }
  },
  watch: {
    '$route.params.type': {
      handler(val) {
        this.currentType = val || '0'
        this.loadData()
      },
      immediate: true
    }
  },
  methods: {
    loadData() {
      const data = this.dataMap[this.currentType] || this.dataMap['0']
      this.bannerData = data.bannerData
      this.practiceData = data.practiceData
      this.imgData = data.imgData;
      this.productShowData = data.productShowData;
      this.cardList = data.cardList;
    }
  }
}
</script>
